// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken  } from "firebase/messaging";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCEdlXvgvbOo1i-Acih-HeG_9_9Tu1q7CA",
  authDomain: "htc-livematch.firebaseapp.com",
  projectId: "htc-livematch",
  storageBucket: "htc-livematch.firebasestorage.app",
  messagingSenderId: "702595385457",
  appId: "1:702595385457:web:7fbeabc21a638e0f1c33d0",
  measurementId: "G-V6WKND09RZ"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app); 
const auth = getAuth(app);


export { app, analytics, db, auth }; // Export the Firestore database instance